import { type SvgIconProps } from '@mui/material';
import React from 'react';

function HeadsIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="28"
      fill="none"
      {...props}
    >
      <path
        d="M4.875 6.00857C2.625 6.00857 0 6.76071 0 8.25857L0 10.5H9.75V8.25857C9.75 6.76071 7.125 6.00857 4.875 6.00857ZM10.5 6.00857C10.3023 6.00857 9.23864 5.98929 9 6.00857C9.79091 6.54857 10.875 7.13357 10.875 8.25857V10.5H15V8.25857C15 6.76071 13.125 6.00856 10.5 6.00857Z"
        fill="#232729"
      />
      <path
        d="M7.125 2.4375C7.125 3.78369 6.03369 4.875 4.6875 4.875C3.34131 4.875 2.25 3.78369 2.25 2.4375C2.25 1.09131 3.34131 0 4.6875 0C6.03369 0 7.125 1.09131 7.125 2.4375Z"
        fill="#232729"
      />
      <path
        d="M13.125 2.4375C13.125 3.78369 12.0337 4.875 10.6875 4.875C9.34131 4.875 8.25 3.78369 8.25 2.4375C8.25 1.09131 9.34131 0 10.6875 0C12.0337 0 13.125 1.09131 13.125 2.4375Z"
        fill="#232729"
      />
    </svg>
  );
}

export default HeadsIcon;
